export default "<div class=\"page-container\">\n<div class=\"elements-container\">\n    <app-note-key-point-list></app-note-key-point-list>\n</div>\n</div>";